<template>
  <b-dropdown-form
    class="py-1 dropdown-filter-form-n"
  >
    <b-row>
      <b-col cols="10">
        <p>Filters</p>
      </b-col>
      <b-col cols="2">
        <feather-icon
          icon="XIcon"
          size="16"
          class="align-right"
          @click="$emit('emitHideFilter')"
        />
      </b-col>
    </b-row>
    <div>
      <b-form-group label="Entitlement Type">
        <b-form-checkbox
          v-for="option in typeOptions"
          :key="option.value"
          v-model="typeFilterValue"
          :value="option.value"
          name="flavour-3a"
        >
          {{ option.label }}
        </b-form-checkbox>
      </b-form-group>
    </div>
    <b-form-group
      label="Scheme"
      @click.native.stop
    >
      <v-select
        v-model="schemeFilterValue"
        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
        label="name"
        multiple
        placeholder="Select from list"
        :options="schemeOptions"
        :clearable="false"
        :reduce="o => o._id"
      />
    </b-form-group>
    <b-form-group
      label="Entitlement Status"
      @click.native.stop
    >
      <v-select
        v-model="statusFilterValue"
        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
        label="value"
        multiple
        placeholder="Select from list"
        :options="statusOptions"
        :clearable="false"
        :reduce="o => o.key"
      />
    </b-form-group>

    <b-form-group
      label="Validity Period"
    >
      <b-input-group>
        <flat-pickr
          v-model="startDateValue"
          class="form-control"
          placeholder="Select date range"
          :config="flatPickrConfig"
        />
        <b-input-group-append is-text>
          <feather-icon
            icon="CalendarIcon"
            class="cursor-pointer"
            data-toggle
            size="18"
          />
        </b-input-group-append>
      </b-input-group>
    </b-form-group>
    <div>
      <b-form-group label="Paid Entitlement">
        <b-form-checkbox
          v-for="option in paidEntitlementOptions"
          :key="option.value"
          v-model="paidEntitlementFilterValue"
          :value="option.value"
          name="flavour-3a"
        >
          {{ option.label }}
        </b-form-checkbox>
      </b-form-group>
    </div>

    <div class="d-flex mt-1">
      <b-button
        variant="outline-primary"
        size="md"
        class="mr-1 w-100"
        @click="clearFilter"
      >
        Clear All
      </b-button>
      <b-button
        variant="primary"
        size="md"
        class="w-100"
        @click="applyFilter"
      >
        Apply Filter
      </b-button>
    </div>
  </b-dropdown-form>
</template>

<script>
import {
  BDropdownForm, BFormGroup, BButton, BRow, BCol, BFormCheckbox, BInputGroup, BInputGroupAppend,
} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import vSelect from 'vue-select'
import '@core/scss/vue/libs/vue-flatpicker.scss'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BButton,
    BDropdownForm,
    BFormGroup,
    BRow,
    BCol,
    flatPickr,
    BFormCheckbox,
    BInputGroup,
    BInputGroupAppend,

    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    vSelect,
  },
  props: {
    startDate: {
      type: [String, null],
      default: null,
    },
    statusFilter: {
      type: [Array, null],
      // eslint-disable-next-line vue/require-valid-default-prop
      default: [],
    },
    typeFilter: {
      type: [Array, null],
      // eslint-disable-next-line vue/require-valid-default-prop
      default: [],
    },
    schemeFilter: {
      type: [Array, null],
      // eslint-disable-next-line vue/require-valid-default-prop
      default: [],
    },
    paidEntitlementFilter: {
      type: [Array, null],
      // eslint-disable-next-line vue/require-valid-default-prop
      default: [],
    },
    schemeOptions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      startDateValue: this.startDate,
      statusFilterValue: JSON.parse(JSON.stringify(this.statusFilter)) || [],
      schemeFilterValue: JSON.parse(JSON.stringify(this.schemeFilter)) || [],
      typeFilterValue: JSON.parse(JSON.stringify(this.typeFilter)) || [],
      paidEntitlementFilterValue: JSON.parse(JSON.stringify(this.paidEntitlementFilter)) || [],
      flatPickrConfig: {
        wrap: true, mode: 'range', dateFormat: 'd/m/Y', enableTime: false, static: true, disableMobile: true,
      },
      typeOptions: [
        { label: 'All', value: 'all' },
        { label: 'Inventory-managed item', value: 1 },
        { label: 'Funeral Service Package', value: 2 },
        { label: 'Non-inventory-managed item', value: 3 },
      ],
      paidEntitlementOptions: [
        { label: 'All', value: 'all' },
        { label: 'Yes', value: 'yes' },
        { label: 'No', value: 'no' },
      ],
      statusOptions: [
        { value: 'Redeemable', key: 'redeemable' },
        { value: 'Redeemed', key: 'redeemed' },
        { value: 'Used', key: 'used' },
        { value: 'Expired', key: 'expired' },
        { value: 'Cancelled', key: 'cancelled' },
      ],
    }
  },
  watch: {
    startDate: {
      immediate: true,
      handler(val) {
        this.startDateValue = val
      },
    },
    statusFilter: {
      immediate: true,
      handler(val) {
        this.statusFilterValue = JSON.parse(JSON.stringify(val)) || []
      },
    },
    schemeFilter: {
      immediate: true,
      handler(val) {
        this.schemeFilterValue = JSON.parse(JSON.stringify(val)) || []
      },
    },
    typeFilter: {
      immediate: true,
      handler(val) {
        this.typeFilterValue = JSON.parse(JSON.stringify(val)) || []
      },
    },
    paidEntitlementFilter: {
      immediate: true,
      handler(val) {
        this.paidEntitlementFilterValue = JSON.parse(JSON.stringify(val)) || []
      },
    },
  },
  methods: {
    applyFilter() {
      this.$emit('update:startDate', this.startDateValue)
      this.$emit('update:statusFilter', this.statusFilterValue)
      this.$emit('update:typeFilter', this.typeFilterValue)
      this.$emit('update:schemeFilter', this.schemeFilterValue)
      this.$emit('update:paidEntitlementFilter', this.paidEntitlementFilterValue)

      this.$emit('emitHideFilter')
    },
    clearFilter() {
      this.startDateValue = ''
      this.statusFilterValue = []
      this.typeFilterValue = []
      this.paidEntitlementFilterValue = []
      this.schemeFilterValue = []
      this.$emit('update:statusFilter', this.statusFilterValue)
      this.$emit('update:typeFilter', this.typeFilterValue)
      this.$emit('update:paidEntitlementFilter', this.paidEntitlementFilterValue)
      this.$emit('update:schemeFilter', this.schemeFilterValue)
      this.$emit('update:startDate', this.startDateValue)

      this.$emit('emitHideFilter')
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
